import './AppModal.css';

//AntDesign imports
import { Button, Modal, Spin } from 'antd';

import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AppModal = (props) => {
  const {title, isModalActive,onHandleModalClose ,onHandleModalSubmit,children,cancelLabel,confirmLabel,showCancelLabel,showConfirmLabel,loading,isSubmitActionLoader,width, disableSubmit} = props;
  //Custom Footer Actions
  const footerActionsArray = (
    <div className="modal-footer" style={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}>
      <Button className="btn btn-Secondary" style={{ display: showCancelLabel ? "block" : "none" }} onClick={onHandleModalClose}>
        {cancelLabel || "Cancel"}
      </Button>
      <Button
        className={`btn btn-submit${disableSubmit ? " disabled" : ""}`}
        style={{ display: showConfirmLabel ? "block" : "none" }}
        disabled={isSubmitActionLoader || loading || disableSubmit}
        onClick={onHandleModalSubmit}>
        {confirmLabel || "Submit"}
        {isSubmitActionLoader && (
          <span>
            <FontAwesomeIcon icon={faCircleNotch} className="submit-loader-icon" />
          </span>
        )}
      </Button>
    </div>
  );

  return (
    <div>
      <Modal
        centered
        maskClosable={false}
        width={width}
        cancelText={cancelLabel}
        okText={confirmLabel}
        title={title || null}
        open={isModalActive}
        onOk={() => setOpen(false)}
        onCancel={onHandleModalClose}
        footer={footerActionsArray}
        className=''
      >
        {loading || false ? (
          <div style={{ display: "flex", justifyContent: "center" }}>  
            <Spin spinning={true} />
          </div>
        ) : (
          children
        )}
      </Modal>
    </div>
  );
}

export default AppModal